export default "__VITE_ASSET__BnRdryOX__"